import { type DomainComponentRegistry } from '@features/server-ui';

import { SemanticBelowGateTile } from './components/domain/SemanticBelowGateTile';
import { SemanticMetricTile } from './components/domain/SemanticMetricTile';

/**
 * semantic-layer DomainComponentRegistry — `type_key -> domain component`.
 * Passed to the shared ServerUiDomainProvider on the metrics dashboard page;
 * context-scoped, so it never collides with jotbill's or the patient page's.
 */
export const semanticDomainComponents: DomainComponentRegistry = {
  semantic_metric_tile: SemanticMetricTile,
  semantic_below_gate: SemanticBelowGateTile,
};
